export async function sendContactMessage(payload) {
  const res = await fetch("/api/contact", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const contentType = res.headers.get("content-type") || "";

  const data = contentType.includes("application/json")
    ? await res.json()
    : await res.text();

  if (!res.ok) {
    console.error("Contact request failed:", {
      status: res.status,
      contentType,
      response: data,
    });

    throw new Error(
      typeof data === "object"
        ? data.message || "Failed to send message"
        : `Server returned ${res.status}: ${data.slice(0, 150)}`,
    );
  }

  return data;
}
